import { useField, useForm } from "mobx-easy-form";
import { Observer, observer } from "mobx-react";
import React from "react";
import * as yup from "yup";
import { TextInputV2 } from "~/components/V2/TextInputV2";
import { EditPetModal } from "../my-pets/EditPetModal";
import type { KeyboardTypeOptions } from "react-native";

export const EditTextInputModal = observer(function EditTextInputModal({
  isVisible,
  onClose,
  onUpdate,
  initialValue,
  placeholder,
  title,
  keyboardType,
  validationSchema,
}: {
  isVisible: boolean;
  onClose: () => void;
  onUpdate: (value: string) => Promise<void>;
  initialValue?: string | null;
  placeholder?: string;
  title: string;
  keyboardType?: KeyboardTypeOptions;
  validationSchema?: yup.Schema;
}) {
  const form = useForm({
    onSubmit: async ({ values }) => {
      const value = values["textInputField"];

      if (initialValue !== value) {
        await onUpdate(value);
      }

      onClose();
    },
  });

  const textInputField = useField({
    form,
    id: "textInputField",
    initialValue: initialValue ?? "",
    validationSchema: validationSchema
      ? validationSchema
      : yup
          .string()
          .required()
          .test(
            "not-only-spaces",
            "Cannot be only spaces.",
            (value) => !!value && value.trim().length > 0,
          ),
  });

  return (
    <>
      {isVisible && (
        <EditPetModal
          onSave={form.actions.submit}
          onClose={onClose}
          title={title}
        >
          <Observer>
            {() => {
              return (
                <TextInputV2
                  value={textInputField.state.value}
                  onChangeText={textInputField.actions.onChange}
                  onFocus={textInputField.actions.onFocus}
                  onBlur={textInputField.actions.onBlur}
                  label={placeholder}
                  keyboardType={keyboardType}
                  isError={!!textInputField.computed.error}
                />
              );
            }}
          </Observer>
        </EditPetModal>
      )}
    </>
  );
});
